<template>
  <v-app
    id="materialpro"
    :class="`${
      !$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'
    }`"
  >
    <router-view v-show="!overlayLoading" />
    <div class="text-center">
      <v-overlay :z-index="zIndex" :value="overlayLoading" opacity="0.9">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
        <h2 class="mt-5">Please Wait...</h2>
      </v-overlay>
    </div>

    <v-overlay :z-index="999" :value="isLoading" opacity="0.5">
      <div
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
        "
      >
        <v-progress-circular indeterminate size="64"></v-progress-circular>
        <span
          v-if="percentLoading.is_use"
          style="position: absolute; top: 20px"
        >
          {{ percentLoading.percent }}%
        </span>
        <h2 class="mt-5">Please Wait</h2>
      </div>
    </v-overlay>

    <ToastAlertSla ref="toastAlertSla" />
  </v-app>
</template>

<script>
import Axios from "@/config/backend-service";
import { mapState } from "vuex";
import {
  firebaseListener,
  firebaseStopListener,
} from "./config/firebaseMessage";
import ToastAlertSla from "./components/notification/toast-alert-sla.vue";

export default {
  name: "App",
  data: () => ({
    zIndex: 205,
    isLoading: false,
    percentLoading: {
      is_use: false,
      percent: 0,
    },

    firebaseTopicAlertSLA: null,
  }),
  components: {
    ToastAlertSla,
  },
  provide() {
    return {
      isAppLoading: async (open, time) => {
        return new Promise((resolve) => {
          const _time = time || 0;
          setTimeout(() => {
            this.isLoading = open;
            if (!open) {
              this.percentLoading.is_use = false;
              this.percentLoading.percent = 0;
            }
            resolve(true);
          }, _time);
        });
      },
      isAppLoadingPercent: async (is_use, percent) => {
        const onSleep = (msec) => {
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve();
            }, msec || 500);
          });
        };
        this.percentLoading.is_use = is_use || false;
        const new_percent = percent || 0;
        const old_percent = this.percentLoading.percent;
        const diff = new_percent - old_percent;
        if (diff >= 0) {
          for (let i = 0; i < diff; i++) {
            const cur_percent = old_percent + i + 1;
            this.percentLoading.percent = cur_percent;
            await onSleep(2);
          }
        } else {
          this.percentLoading.percent = 0;
        }
      },
    };
  },
  computed: {
    ...mapState("defaultSystem", ["user"]),
    overlayLoading: {
      set() {
        this.$store.commit("defaultSystem/SET_LOADING", false);
      },
      get() {
        return this.$store.getters["defaultSystem/getLoading"];
      },
    },
  },
  watch: {
    overlayLoading: {
      handler() {
        this.overlayLoading;
      },
      deep: true,
    },
  },
  async created() {
    // await this.getSiteMaintenance();
    this.getAccount();
    if (
      !["/system-privacy-policy", "/system-term-of-service"].includes(
        window.location.pathname
      )
    ) {
      this.getNotiSideBar();
    }
  },
  async mounted() {},
  beforeDestroy() {
    if (this.firebaseTopicAlertSLA) {
      firebaseStopListener(this.firebaseTopicAlertSLA);
    }
  },
  methods: {
    async getNotiSideBar() {
      Axios.get("getNotiSideBar")
        .then((res) => {
          const dataResponse = res?.data?.data;
          if (dataResponse) {
            localStorage.setItem(
              "noti",
              JSON.stringify(dataResponse.notification)
            );
          }
        })
        .catch((err) => {
          console.log("getNotiSideBar", err);
        });
    },
    getAccount() {
      let _user = this.user;
      if (_user) {
        Axios.get("getAccount")
          .then((res) => {
            const dataResponse = res?.data;
            if (dataResponse?.user) {
              const user = dataResponse.user;
              if (_user) {
                _user.permissions = user.permissions;
                _user.brand_permissions = user.brand_permissions;
                _user.branch_permissions = user.branch_permissions;
                _user.partner = user.partner;
                _user.company_logo = user.company_logo;
                _user.profile_path = user.profile_path;
                _user.main_profile_path = user.main_profile_path;
                _user.site_expired = user.site_expired;
                _user.list_site = user.list_site || [];
                _user.work_status = user.work_status;
                this.$store.commit("defaultSystem/SET_USER", _user);
                this.setRealtimeAlert(user.site_id);
              }
            }
          })
          .catch((err) => {
            console.log("getAccount", err);
          });
      }
    },
    async getSiteMaintenance() {
      try {
        const response = Axios.get("getSiteMaintenance");
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          if (dataResponse?.message == "maintenance") {
            this.$router.push({
              name: "maintenance",
            });
          }
        }
      } catch (err) {
        console.log("getSiteMaintenance", err);
      }
    },
    getAdminInAppNoti() {
      let user_ = this.$store?.state?.defaultSystem?.user;
      if (user_) {
        Axios.get("getAdminInAppNoti")
          .then((res) => {
            const dataResponse = res?.data;
            if (dataResponse?.status == "success") {
              const data = dataResponse.data;
              const message = data.message;
              alert(message);
            }
          })
          .catch((err) => {
            console.log("getAdminInAppNoti", err);
          });
      }
    },

    // ========== ========== Realtime ========== ==========
    setRealtimeAlert(site_id) {
      const topic = `response_sla_alerted_at/${site_id}`;
      if (!this.firebaseTopicAlertSLA) {
        firebaseListener(topic, (data) => {
          this.realtimeAlert(topic, data);
        });
        this.firebaseTopicAlertSLA = topic;
      }
    },
    async realtimeAlert(topic, data) {
      const admin_ids = data?.admin_ids ?? [];
      if (admin_ids.length == 0 || !admin_ids.includes(this.user.id)) {
        return;
      }
      // ========== ========== ========== ==========
      this.$store.commit("defaultSystem/SET_SLA_ALERT", { ...data });
      this.toastAlert(data);
      // ========== ========== ========== ==========
    },
    async toastAlert(data) {
      if (!data) {
        return;
      }
      // ========== ========== ========== ==========
      if (!this.$refs.toastAlertSla) {
        return;
      }
      this.$refs.toastAlertSla.addToast({
        id: data.id,
        sla_type: data.sla_type,
        chat_room_name: data.chat_room_name,
        chat_room_image: data.chat_room_image,
        seconds_before_due: data.seconds_before_due,
      });
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Athiti:wght@400;500;600&display=swap");
@import url("./assets/styles/ql-editor.css");

body {
  font-family: "Poppins", "Athiti" !important;
}

.card-css {
  --bs-card-spacer-y: 1rem !important;
  --bs-card-spacer-x: 1rem !important;
  --bs-card-title-spacer-y: 0.5rem !important;
  --bs-card-border-width: 0 !important;
  --bs-card-border-color: rgba(0, 0, 0, 0.125) !important;
  --bs-card-border-radius: 1rem !important;
  --bs-card-box-shadow: 0 0 2rem 0rgba (136, 152, 170, 0.15) !important;
  --bs-card-inner-border-radius: 1rem !important;
  --bs-card-cap-padding-y: 0.5rem !important;
  --bs-card-cap-padding-x: 1rem !important;
  --bs-card-cap-bg: #fff !important;
  --bs-card-bg: #fff !important;
  --bs-card-img-overlay-padding: 1rem !important;
  --bs-card-group-margin: 0.75rem !important;
  position: relative !important;
  display: flex !important;
  flex-direction: column !important;
  min-width: 0 !important;
  height: var(--bs-card-height) !important;
  word-wrap: break-word !important;
  background-color: var(--bs-card-bg) !important;
  background-clip: border-box !important;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color) !important;
  border-radius: var(--bs-card-border-radius) !important;
}
.svc-creator__banner {
  display: none !important;
}
</style>
